<template>
    <div class="container-fluid" aria-label="Enter your login details to proceed">

		<div class="row top_bar" v-if="!isShibLogin">
			<div class="col-12">
				<div class="row header">
                  <div class="col-4">

                  </div>
		            <div class="col-4 logo_container" style="text-align: center;">
		            	<a href="https://site.pragyasystems.com/">
      							<img class="logo" src="../../../assets/theme/default/img/pragyaLogo2020.svg" style="height: 80px !important; width: auto !important; margin-top: -14px; max-height: 80px;" alt="Pragya Systems Logo">
      						</a>
		            </div>

		            <div class="col-4 hd_lnk_container" style="text-align: right; padding-top: 80px;">
                  <a href="https://site.pragyasystems.com/" style="margin-right: -55px;">
      							Back to Pragya Website
      						</a>
		            </div>


			        <!-- == ################################################### == -->

				</div>
			</div>
		</div>

        <template v-if="isShibLogin">
            <div id="loading_wait_message">
                <div style="margin: 20px 0; font-family: cursive; font-size: 20px; color: #787878; text-align: center;">Redirecting to Pragya Systems, please wait...</div>
            </div>
        </template>

        <template v-else>
            <template v-if="showPrivacyPolicy">

              <privacy-policy></privacy-policy>
              <div class="row page_fld_section close_button">
                 <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8">
                 </div>
                 <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                   <b-button size="lg" @click="hidePrivacyPolicyTab()" aria-label="close" style="float: right;">Close</b-button>
                 </div>
             </div>
            </template>
            <template v-if="!showPrivacyPolicy">
            <div class="row user-login-section">
              <div class="col-12">

                <div class="row">

                  <!--
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 user-login-section-left">

                      <div class="row" style="height: 100%;">
                        <div class="col-12" style="height: 100%; padding-top: 40px;">
                      		<img class="img-login" src="../../../assets/theme/default/img/login.png" />
                      	</div>
                      </div>

                  </div>
                  -->

                  <div class="col-xl-4 col-lg-5 col-md-6 col-sm-10 user-login-section-right" style="margin: auto;">

                      <div class="row">
  	                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 login-user-section login_sec_box" @keydown.enter="login">

  	                        <div class="row page_fld_section" style="margin-bottom: 10px;">
  	                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
  	                                <div class="landing-page-heading">Login directly into Pragya</div>
  	                            </div>
  	                        </div>

  	                        <div class="row page_fld_section" style="height: 20px; margin-bottom: 10px;">
  	                            <div class="col-12" id="validation-message" style="display: none">
  	                                <div style="color: #ff0000; text-align: center;">{{errorMessage}}</div>
  	                            </div>
  	                        </div>

  	                        <div class="row page_fld_section" style="margin-bottom: 25px;">
  	                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
  	                                <div class="fld-label" id="eMail">Email</div>
  	                            </div>
  	                            <div class="col-xl-8 col-lg-9 col-md-9 col-sm-12">
                                      <b-form-input type="email" v-model.email="eMail" :state="eMailState"
                                          aria-labelledby="email" placeholder="Email" @blur.native="$v.eMail.$touch()"
                                          aria-describedby="eMailFeedback" style="height: 1.5em !important;" autofocus>
                                      </b-form-input>
                                      <b-form-invalid-feedback id="eMailFeedback">
                                          Please enter a proper email address.
                                      </b-form-invalid-feedback>
  	                            </div>
  	                        </div>

  	                        <div class="row page_fld_section" style="margin-bottom: 25px;">
  	                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
  	                                <div class="fld-label" id="password">Password</div>
  	                            </div>
  	                            <div class="col-xl-8 col-lg-9 col-md-9 col-sm-12 password_input_fld">
                                  <b-form-input v-if="showPassword" type="text" v-model.trim="password" :state="passwordState"
                                      aria-labelledby="password" placeholder="Password" @blur.native="$v.password.$touch()"
                                      aria-describedby="passwordFeedback" style="height: 1.5em !important;">
                                  </b-form-input>
                                  <b-form-input v-else type="password" v-model.trim="password" :state="passwordState"
                                      aria-labelledby="password" placeholder="Password" @blur.native="$v.password.$touch()"
                                      aria-describedby="passwordFeedback" style="height: 1.5em !important;">
                                  </b-form-input>
                                  <div class="control">
                                    <button class="button" @click="toggleShowPassword" aria-label="View Password">
                                      <span class="icon is-small is-right">
                                        <span class="fas" :class="{ 'fa-eye': showPassword, 'fa-eye-slash': !showPassword }"></span>
                                      </span>
                                    </button>
                                  </div>
                                  <b-form-invalid-feedback id="passwordFeedback">
                                    Password must not be empty.
                                  </b-form-invalid-feedback>
  	                            </div>
  	                        </div>

  	                         <div class="row page_fld_section">
  	                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
  	                            	<a href="javascript://" @click="forgotPassword">Forgot Password?</a>
  	                            </div>
  	                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
  	                            </div>
  	                        </div>
                             <div class="row page_fld_section">
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                                  <a href="javascript://" @click="pragyaSignup">Don't have an account? Sign up to explore</a>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                                  <b-button size="lg" @click="login" aria-label="login" style="float: right;">login</b-button>
                                </div>
                            </div>

  	                    </div>
  	                </div>

                  </div>

                </div>


                <div class="footer-login row text-center">
                	<div class="col-12">
    					<div class="page-footer">
    						<span> &copy; </span>
    						<span>Copyright Pragya Systems Inc. All rights reserved.</span>
                <p class="color-white"><b-link @click="showPrivacyPolicyTab()">Privacy Policy</b-link></p>
    					 </div>
    				</div>
            	</div>

        </div>
			</div>



            <div>
                <b-modal v-model="showNotConnectedModal" title="Not Connected Yet!" :header-bg-variant="'warning'" :header-text-variant="'dark'" :footer-bg-variant="'light'" no-close-on-backdrop no-close-on-esc centered>
                    <div class="text-center">
                        <h3 style="margin-bottom: 20px;">{{notConnectedOrgName}}</h3>
                        <span v-html="insLoginErrorMessage"></span>
                    </div>
                    <div slot="modal-footer" class="w-100">
                        <b-button variant="primary" size="sm" class="float-right" @click="showNotConnectedModal = false">close</b-button>
                    </div>
                </b-modal>
            </div>

            <div>
                <b-modal v-model="showForgotPasswordModal" title="Forgot Password" :footer-bg-variant="'light'" no-close-on-backdrop no-close-on-esc centered>
                    <div class="text-center" @keydown.enter="resetPassword">
                        <template v-if="resetPasswordMessage">
                            <span>{{resetPasswordMessage}}</span>
                        </template>
                        <template v-else>
                            <div class="float-left mr-3" style="margin-top: 10px;">
                                <div class="fld-label">User Email</div>
                            </div>
                            <div class="ml-5">
                                <b-form-input type="email" v-model.email="resetPasswordEmail" :state="resetPasswordEmailState"
                                    aria-labelledby="reset email" placeholder="Email" @blur.native="$v.resetPasswordEmail.$touch()"
                                    aria-describedby="resetPasswordEmailFeedback" style="height: 1.5em !important; width: 70%;">
                                </b-form-input>
                                <b-form-invalid-feedback id="resetPasswordEmailFeedback">
                                    Please enter a proper email address.
                                </b-form-invalid-feedback>
                            </div>
                        </template>
                    </div>
                    <div slot="modal-footer" class="w-100">
                        <template v-if="resetPasswordMessage">
                            <b-button variant="primary" size="sm" class="float-right" @click="showForgotPasswordModal = false">ok</b-button>
                        </template>
                        <template v-else>
                            <b-button variant="primary" size="sm" class="float-right ml-3" @click="resetPassword">get new password</b-button>
                            <b-button variant="primary" size="sm" class="float-right" @click="showForgotPasswordModal = false">cancel</b-button>
                        </template>
                    </div>
                </b-modal>
            </div>

            <div class="lgn_sec_modal">
                <b-modal v-model="showSSOModal" title="Log in with your institution" no-close-on-backdrop no-close-on-esc centered>
                    <div class="text-center">
                            <div class="float-left mr-3">
                                <div class="fld-label mb-3">
                                  Looks like you have an account with <br/>
                                  <b><i>{{ssoInstitutionName}}</i></b>
                                </div>
                                <div class="fld-label">Please click on the button below to log in with your <b><i>{{ssoInstitutionName}}</i></b> credentials. </div>
                            </div>
                    </div>
                    <div slot="modal-footer" class="w-100">
                      <div class="modal_logo_container">
                        <img class="inst_logo" :src="ssoInstitutionLogo" v-if="ssoInstitutionLogo">
                      </div>
                      <b-button variant="primary" size="sm" class="btn float-right ml-3 mt-3" @click="institutionLogin">go to institution login</b-button>
                    </div>
                </b-modal>
            </div>
            <div class="lgn_sec_modal">
                <b-modal v-model="showSSOPasswordModal" title="Change password with your institution" no-close-on-backdrop no-close-on-esc centered>
                    <div class="text-center">
                            <div class="float-left mr-3">
                                <div class="fld-label mb-3">
                                  Looks like you have an account with <br/>
                                  <b><i>{{ssoInstitutionName}}</i></b>
                                </div>
                                <div class="fld-label">Please click on the button below to change password with your <b><i>{{ssoInstitutionName}}</i></b>. </div>
                            </div>
                    </div>
                    <div slot="modal-footer" class="w-100">
                      <div class="modal_logo_container">
                        <img class="inst_logo" :src="ssoInstitutionLogo" v-if="ssoInstitutionLogo">
                      </div>
                      <b-button variant="primary" size="sm" class="btn float-right ml-3 mt-3" @click="institutionLogin">go to institution login</b-button>
                    </div>
                </b-modal>
            </div>


            <div class="loading-spinner">
                <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                    <div class="text-center" style="color: #FFF">
                        <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                    </div>
                </b-modal>
            </div>
          </template>
        </template>

    </div>
</template>

<script>
  import Vue from 'vue'
  import { mapActions, mapState } from 'vuex'
  import Autocomplete from 'vuejs-auto-complete'
  import Vuelidate from 'vuelidate'
  import {required, email} from 'vuelidate/lib/validators'
  import PrivacyPolicy from '../../user/components/PrivacyPolicy'
  Vue.use(Vuelidate)
  import { StorageFactory } from '../../../storageFactory'
  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'login',
    components: {
      Autocomplete,
      PrivacyPolicy
    },
    data: () => {
      return {
        eMail: '',
        eMailState: null,
        password: '',
        passwordState: null,
        showPassword: false,
        errorMessage: '',
        currentEnvironment: {},
        ssoConfigurationList: [],
        notConnectedOrgName: null,
        showNotConnectedModal: false,
        showForgotPasswordModal: false,
        showSSOModal: false,
        showSSOPasswordModal:false,
        ssoPath : undefined,
        ssoInstitutionName:undefined,
        ssoInstitutionLogo:undefined,
        resetPasswordEmail: '',
        resetPasswordEmailState: null,
        resetPasswordMessage: null,
        insLoginErrorMessage: 'Sorry! You cannot use your institutional login at this time. <br/>If you already have a Pragya account, login directly. <br/> If not, sign up and start using Pragya today!',
        token: null,
        openId: null,
        redirect: null,
        isShibLogin: false,
        showPrivacyPolicy: false
      }
    },

    validations: {
      resetPasswordEmail: {
        required,
        email
      },
      eMail: {
        required,
        email
      },
      password: {
        required
      }
    },

    watch: {
      eMail (val) {
        if (val) {
          this.eMailState = true
        } else {
          this.eMailState = null
        }
      },

      password (val) {
        if (val) {
          this.passwordState = true
        } else {
          this.passwordState = null
        }
      },

      resetPasswordEmail (val) {
        if (val) {
          this.resetPasswordEmailState = true
        } else {
          this.resetPasswordEmailState = null
        }
      }
    },

    computed: {
      ...mapState({
        'ssoConfig': state => state.login.ssoConfig
      })
    },

    mounted () {
      if (this.$route.query.showPrivacyPolicy) {
        this.showPrivacyPolicyTab()
      }

      if (this.$route.query.token) {
        this.isShibLogin = true
        this.token = this.$route.query.token
        this.openId = this.$route.query.openId
        this.redirect = this.$route.query.redirect
        this.shibLogin()
      } else {
        this.getSSOConfiguration()
      }

      let utm_medium = this.getQueryParamByName('utm_medium')
      localStore.setItem('utm_medium', utm_medium)
      let utm_source = this.getQueryParamByName('utm_source')
      localStore.setItem('utm_source', utm_source)
      let utm_campaign = this.getQueryParamByName('utm_campaign')
      localStore.setItem('utm_campaign', utm_campaign)
      let utm_content = this.getQueryParamByName('utm_content')
      localStore.setItem('utm_content', utm_content)
      let utm_term = this.getQueryParamByName('utm_term')
      localStore.setItem('utm_term', utm_term)

      this.resetSelectedFactes()
    },

    methods: {
      ...mapActions([
        'loadSSOConfiguration',
        'loadResetPassword',
        'loadEnvironment',
        'loadLoginUser',
        'loadShibLogin',
        'setUserInfo',
        'resetSelectedFactes'
      ]),

      toggleShowPassword () {
        this.showPassword = !this.showPassword;
      },

      getQueryParamByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&')
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
        let results = regex.exec(decodeURIComponent(url))
        if (!results || !results[2]) return ''
        let value = results[2].replace(/\+/g, ' ')
        return value
      },

      showPrivacyPolicyTab () {
        this.showPrivacyPolicy = true
      },

      hidePrivacyPolicyTab () {
        this.showPrivacyPolicy = false
      },

      getSSOConfiguration () {
        if (!this.$parent.isSessionExpired()) {
          let path = this.$router.currentRoute.path
          if (path === '/login') {
            let role = localStorage.getItem('userrole')
            if (role === 'SuperAdmin') {
              return this.$router.push({ name: 'superAdminDashboard' })
            } else {
              this.$store.commit('LOAD_USER_ROLE', role)
              this.navigateToDashboard(role)
            }
          }
        } else {
          this.loadSSOConfiguration().then(res => {
            if (res && res.status !== 503) {
              let data = res.data
              let shibboleth = data['shibboleth']
              const config = shibboleth.map(({id, openId, organizationName: name, targetURI, enable}) => ({
                id,
                openId,
                name,
                targetURI,
                enable
              }))
              this.ssoConfigurationList = config
              this.getEnvironment()
              this.$root.$emit('serviceAvailable', true)
            } else {
              let errorThrown = res.statusText
              this.$root.$emit('serviceAvailable', false, errorThrown)
            }
          })
        }
      },

      getEnvironment () {
        if (Object.keys(this.currentEnvironment).length === 0) {
          this.loadEnvironment().then(res => {
            if (res && res.status !== 503) {
              this.currentEnvironment = res.data
            }
          })
        }
      },

      selectConfig (item) {
        let config = item.selectedObject
        this.loadShibbolethURL(config.name, config.id, config.targetURI, config.enable, config.openId)
      },

      loadShibbolethURL (name, entityId, targetURI, status, openId) {
        if (status === 'true') {
          let href = window.location.href.split('?')
          let paramValues = []
          if (href.length > 1) {
            let paramsString = href[1]
            paramValues = paramsString.split('=')
          }
          let secureHost = this.currentEnvironment.secureHost
          let loginUrl = secureHost
          loginUrl += '/Shibboleth.sso/Login?entityID=' + entityId
          if (paramValues.length > 1) {
            let redirect = paramValues[1].split('&')
            loginUrl += '&target=' + secureHost + targetURI + '?openId=' + openId + '__' + redirect[0]
          } else {
            loginUrl += '&target=' + secureHost + targetURI + '?openId=' + openId
          }
          window.location.href = loginUrl
        } else {
          this.notConnectedOrgName = name
          this.showNotConnectedModal = true
          this.$refs.autocomplete.clear()
        }
      },

      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },

      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },

      forgotPassword () {
        this.resetPasswordEmail = ''
        this.resetPasswordMessage = null
        this.resetPasswordEmailState = null
        this.showForgotPasswordModal = true
        this.$v.resetPasswordEmail.$touch()
      },
      pragyaSignup (){
        window.open(window.location.origin + '/signup/open', '_self')
      },
      resetPassword () {
        this.$v.resetPasswordEmail.$touch()
        if (this.$v.resetPasswordEmail.$error) {
          this.resetPasswordEmailState = false
        }
        if (this.resetPasswordEmailState) {
          this.loadResetPassword(this.resetPasswordEmail).then(res => {
            if (res.status === 401) {
              this.resetPasswordMessage = 'This email "' + this.resetPasswordEmail + '" does not exist.'
            } else if (res.status === 500) {
              this.resetPasswordMessage = 'Error in service call.'
            } else {
              if (res.data && res.data.ssoEnabled) {
                this.showForgotPasswordModal = false
                this.showSSOPasswordModal = true
                this.ssoInstitutionName = res.data.ssoInstitutionName
                this.ssoPath = res.data.ssoPath
                this.ssoInstitutionLogo = res.data.ssoInstitutionLogo
              }else{
                this.resetPasswordMessage = 'Please check your registered email for password reset instructions.'
              }
            }
          })
        }
      },

      login () {
        this.$v.eMail.$touch()
        this.$v.password.$touch()
        if (this.$v.eMail.$error) {
          this.eMailState = false
        }
        if (this.$v.password.$error) {
          this.passwordState = false
        }
        if (this.eMailState && this.passwordState) {
          this.showLoader()
          let href = window.location.href.split('?')
          let paramValues = []
          if (href.length > 1) {
            let paramsString = href[1]
            paramValues = paramsString.split('=')
          }
          this.loadLoginUser({eMail: this.eMail, password: this.password}).then(res => {
            this.$store.commit('LOAD_ALL_CHANNELS', [])
            this.$store.commit('LOAD_LEARNING_SPACES', [])
            let status = res.status
            let userObj = res.data
            if (status === 200) {
              if(this.checkSSOEnabled(userObj)){
                  return
              }
              if (!this.validateTnC(userObj)) {
                this.hideLoader()
                this.setUserInfo(userObj)

                if (!paramValues.length > 1) {
                  return this.$router.push({name: 'termsAndConditions', params: {userObj: userObj}, query: {redirect: paramValues[1]}})
                } else {
                  return this.$router.push({name: 'termsAndConditions', params: {userObj: userObj}})
                }
              } else {
                this.hideLoader()
                $('#launcher').show()
                this.setUserInfo(userObj)
                let role = userObj.roles[0].role
                if (role === 'SuperAdmin') {
                  return this.$router.push({ name: 'superAdminDashboard' })
                } else {
                  this.navigateToDashboard(role)
                }
              }
            } else {
              this.hideLoader()
              switch (status) {
                case 503:
                  this.errorMessage = 'Server temporarily unavailable'
                  break
                case 401:
                  this.errorMessage = 'Invalid email or password'
                  break
                case 400:
                  this.errorMessage = 'Please enter all required fields'
                  break
                default:
                  this.errorMessage = 'Unexpected error code: ' + status
                  break
              }
              $('#validation-message').fadeIn('fast').delay(2000).fadeOut('slow')
            }
          })
        }
      },
      checkSSOEnabled (userObj) {
        if(userObj.ssoEnabled){
            this.showSSOModal = true
            this.ssoPath = userObj.ssoPath
            this.ssoInstitutionName = userObj.ssoInstitutionName
            this.ssoInstitutionLogo = userObj.ssoInstitutionLogo
        }
        return userObj.ssoEnabled
      },
      institutionLogin () {
        window.location.href = window.location.origin + '/sso/' + this.ssoPath

      } ,
      validateTnC (userObj) {
        let permission = userObj.permission
        if (!permission.institutionPermission.create && !userObj.tnCAccepted) {
          return false
        }
        return true
      },

      shibLogin () {
        this.loadShibLogin(this.token).then(userObj => {
          this.setUserInfo(userObj, this.openId)
          let role = userObj.roles[0].role
          this.navigateToDashboard(role)
        })
      },

      navigateToDashboard (userRole) {
        this.$parent.isUserLoggedIn = true
        this.$parent.isServiceAvailable = true
        let role = userRole.toLowerCase()
        let url = '/user/track/' + role
        if ((role === 'instructor & admin')) {
          url = '/user/track/admin'
        } else if (role === 'curator') {
          url = '/dashboard/instructor'
        }else if (role === 'employer admin') {
          url = '/employer/admin'
        } else if (role === 'prospective student' || role === 'admitted student' || role === 'widget admin') {
          url = '/user/track/' + role.split(' ').join('_')
        }
        return this.$router.push(url)
      }
    }
  }
</script>

<style scoped>
.color-white a {
  color: #ffffff;
}
.close_button {
  margin-top: 10px;
}
.hd_lnk_container {
	text-align: right;
	padding-top: 20px;
}
.modal_logo_container {
  text-align: center;
}
.modal_logo_container .inst_logo,
.modal_logo_container img {
  max-height: 80px;
  width: auto;
  margin: 0 auto;
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/app/login/components/Login.vue